import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { withRouter } from 'react-router-dom';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import ActivitiesAndNotesComponent from '../../Components/ActivitiesAndNotesComponent/ActivitiesAndNotesComponent';
import metadata from './OpenActivities.metadata.json5';

class OpenActivities extends Component {

    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({
                accountNumber: PropTypes.string
            }),
            accountActivitiesData: PropTypes.shape({
                getUpdateCountInfo: PropTypes.func.isRequired
            })
        }).isRequired
    };

    getMetadataImplementation = () => {
        const {
            fromAccountLanding: {
                accountDetailsData: { accountNumber }
            }
        } = this.props;

        const { authHeader } = this.props;
        const overrides = {
            accountDetailsActivitiesContainer: {
                accountNumber: accountNumber,
                authHeader: authHeader
            }
        };
        const resolvers = {
            resolveComponentMap: {
                ActivitiesAndNotesComponent: ActivitiesAndNotesComponent
            }
        };
        return <MetadataContent uiProps={metadata.pageContent} overrideProps={overrides} {...resolvers} />;
    };

    render() {
        return this.getMetadataImplementation();
    }
}
export const OpenActivitiesCoponent = OpenActivities;

export default withRouter(withViewModelService(withAuthenticationContext(OpenActivities)));
